import {
  AbstractControl,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';

export function sourcesValidator({
  minLength,
  maxLength,
}: {
  minLength?: number;
  maxLength: number;
}): ValidatorFn {
  return Validators.compose([
    minLength
      ? ({ value }: AbstractControl<unknown>) => {
          if (!value || !Array.isArray(value)) {
            return { sourcesInvalid: true };
          }
          if (value.length < minLength) {
            return { sourcesInferiorMinLength: true };
          }
          return null;
        }
      : null,
    ({ value }: AbstractControl<unknown>) => {
      if (!value || !Array.isArray(value)) {
        return { sourcesInvalid: true };
      }
      if (value.length > maxLength) {
        return { sourcesExceedMaxLength: true };
      }
      return null;
    },
    ({ value }: AbstractControl<unknown>): ValidationErrors | null => {
      if (!value || !Array.isArray(value)) {
        return { sourcesInvalid: true };
      }
      if (value.every(v => typeof v === 'string')) {
        return null;
      }
      return { sourcesInvalidType: true };
    },
  ]);
}
